import { FormattedMessage } from "react-intl";
import {
  uploadFileToS3,
  deleteFileFromS3,
} from "@pages/WorksitesDocuments/utils/FilesAndS3Utils";

const ACCEPTED_FORMATS = [
  "image/*",
  "application/pdf",
  ".xls",
  ".xlsx",
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
];

const maxSize = 10000000;

const refreshTable = async (apiRequest, setData, push) => {
  try {
    const data = await apiRequest.get(`/public_links/all`);
    setData(data);
  } catch (error) {
    push({
      title: <FormattedMessage id="server_error" />,
      type: "error",
    });
  }
};

export const GetDeletePublicLink = (push, apiRequest, setData) => {
  return async (row) => {
    // Step 1: check if has services configurations
    const filename = row.link.split("/").pop();
    let res = await apiRequest.get(
      `/public_links/has-service-configurations/${filename}`
    );
    if (!res.hasConfigurationServices) {
      // Step 2: delete public_link
      await apiRequest.get(`/public_links/delete/${filename}`)
      // Step 3: refresh table
      await refreshTable(apiRequest, setData, push);
      push({
        type: "success",
        title: (
          <FormattedMessage
            id="delete_public_link_success"
            defaultMessage="Public link cancellato correttamente"
          />
        ),
      });
    } else {
      push({
        type: "error",
        title: (
          <FormattedMessage
            id="delete_public_link_error"
            defaultMessage="Public link in utilizzo"
          />
        ),
      });
    }
  };
};

export const UploadPublicLink = async (
  row,
  push,
  apiRequest,
  edit,
  setData,
  setLoading
) => {
  const fileLoader = document.createElement("input");
  fileLoader.type = "file";
  fileLoader.multiple = !edit;
  fileLoader.className = "hidden";
  fileLoader.accept = ACCEPTED_FORMATS.join(", ");

  fileLoader.onchange = async (e) => {
    setLoading(true);
    let newList = [];
    let size = 0;
    Object.keys(e.target.files).forEach((key) => {
      newList.push(e.target.files[key]);
      size += e.target.files[key].size;
    });
    if (size > maxSize) {
      push({
        type: "error",
        title: <FormattedMessage id="size_limit_exceeded" />,
      });
    } else {
      const filesUploaded = await Promise.all(
        newList.map(async (file) => {
          // Step 1: add new public_link
          try{
            const fields = await uploadFileToS3(
              apiRequest,
              file,
              `public_links`,
              "public_links",
              true,
              true
            );
          } catch(e){
            push({
              type: "error",
              title: (
                <FormattedMessage
                  id="upload_public_link_error"
                  defaultMessage="Errore durante l'upload del public link"
                />
              ),
            });
            return;
          }
          // Nel caso in cui i due filename siano uguali il replace è implicito
          let source = row?.filename;
          let destination = file?.name;
          if (edit && source !== destination) {
            // Step 2: replace old public_link
            try {
              await apiRequest.post(`/public_links/replace`, {
                source,
                destination,
              });
              push({
                type: "success",
                title: (
                  <FormattedMessage
                    id="replace_public_link_success"
                    defaultMessage="Public link sostituito correttamente"
                  />
                ),
              });
            } catch (e) {
              push({
                type: "error",
                title: (
                  <FormattedMessage
                    id="replace_public_link_error"
                    defaultMessage="Errore durante la sostituzione del public link"
                  />
                ),
              });
            } finally {
              setLoading(false);
            }
          }
        })
      );
      // Step 4: refresh table
      await refreshTable(apiRequest, setData, push);
    }
    setLoading(false);
  };
  fileLoader.click();
};
